<template>
  <div>
    <apexchart
      v-if="data.length"
      :id="$attrs.chart_id"
      type="bar"
      height="600"
      :options="chartOptions"
      :series="series"
      ref="chart"
      @legendClick="updateEnabledSeries"
    />
    <div v-else class="text-center font-weight-bold text-uppercase h5 p-2 mt-2" style="color: black">
      No results found
    </div>

    <!-- Modal -->
    <div
      class="modal fade"
      :id="$attrs.chart_id ? $attrs.chart_id + '_eventModal' : 'eventModal'"
      tabindex="-1"
      role="dialog"
      aria-labelledby="eventModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-xl modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="eventModalLabel">
              {{ selectedEvent?.event }}
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" v-if="selectedEvent">
            <div class="row mb-3">
              <div class="col-auto">
                <nav aria-label="...">
                  <ul class="pagination text-smallest mb-0 pb-0">
                    <li class="page-item" :class="{ 'disabled': pagination.currentPage === 1}">
                      <button class="page-link" @click="accidentIncidentByEventData(1,year,office,years)">First</button>
                    </li>

                    <li v-for="page in paginationPages" :key="page" class="page-item" :class="{ 'disabled': page === '...', 'active': page === pagination.currentPage }">
                      <button class="page-link" @click="accidentIncidentByEventData(page,year,office,years)">{{ page }}</button>
                    </li>

                    <li class="page-item" :class="{ 'disabled': pagination.currentPage === pagination.lastPage}">
                      <button class="page-link" @click="accidentIncidentByEventData(pagination.lastPage,year,office,years)">Last</button>
                    </li>
                  </ul>
                </nav>
              </div>
              <div class="col-auto">
                <select name="year" id="year" v-model="year" @change.prevent="accidentIncidentsByEventAndYear()" class="form-control form-control-sm">
                  <option :value="null">{{Math.min(...years)}}-{{Math.max(...years)}}</option>
                  <option :value="year" v-for="year in years">
                    {{year}}
                  </option>
                </select>
              </div>
              <div class="col-auto" v-if="['k-line-persons', 'k-line-persons2'].includes(user.roles_permissions?.roles[0]) === false">
                <button class="btn btn-dark btn-sm force-white-all" :disabled="!resultEvent.length" @click.prevent="generateCsv"><font-awesome-icon icon="download" class="mr-2"></font-awesome-icon>DOWNLOAD CSV</button>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <table class="table table-bordered table-responsive">
                  <thead>
                  <template v-if="$route.params.chart_module === 'number_of_report' || $route.params.chart_module === 'immediate_cause' || $route.params.chart_module === 'root_cause'">
                    <tr>
                      <td class="text-uppercase text-center font-weight-bold align-middle" style="background-color: #e1e1e1 ;color: black">#</td>
                      <td class="text-uppercase text-center font-weight-bold align-middle" style="background-color: #e1e1e1 ;color: black">Vessel</td>
                      <td class="text-uppercase text-center font-weight-bold align-middle" style="background-color: #e1e1e1 ;color: black">Manager</td>
                      <td class="text-uppercase text-center font-weight-bold align-middle" style="background-color: #e1e1e1 ;color: black">Report Title</td>
                      <td class="text-uppercase text-center font-weight-bold align-middle" style="background-color: #e1e1e1 ;color: black">Event Date</td>
                      <td class="text-uppercase text-center font-weight-bold align-middle" style="background-color: #e1e1e1 ;color: black">Event 1</td>
                      <td class="text-uppercase text-center font-weight-bold align-middle" style="background-color: #e1e1e1 ;color: black">Event 2</td>
                      <td class="text-uppercase text-center font-weight-bold align-middle" style="background-color: #e1e1e1 ;color: black">Event 3</td>
                      <td class="text-uppercase text-center font-weight-bold align-middle" style="background-color: #e1e1e1 ;color: black">Event 4</td>
                      <template v-if="$attrs.chart_id === 'ai_imm_cause' && $route.params.chart_module === 'number_of_report'">
                        <td class="text-uppercase text-center font-weight-bold align-middle" style="background-color: #e1e1e1 ;color: black;">Substandard Act</td>
                        <td class="text-uppercase text-center font-weight-bold align-middle" style="background-color: #e1e1e1 ;color: black;">Substandard Condition</td>
                      </template>
                      <template v-if="$attrs.chart_id === 'ai_root_cause' && $route.params.chart_module === 'number_of_report'">
                        <td class="text-uppercase text-center font-weight-bold align-middle" style="background-color: #e1e1e1 ;color: black;">Root Cause</td>
                        <td class="text-uppercase text-center font-weight-bold align-middle" style="background-color: #e1e1e1 ;color: black;">Factor of Root Cause</td>
                      </template>
                      <template v-if="$route.params.chart_module === 'immediate_cause'">
                        <td class="text-uppercase text-center font-weight-bold align-middle" style="background-color: #e1e1e1 ;color: black;">Substandard Act</td>
                        <td class="text-uppercase text-center font-weight-bold align-middle" style="background-color: #e1e1e1 ;color: black;">Substandard Condition</td>
                      </template>
                      <template v-if="$route.params.chart_module === 'root_cause'">
                        <td class="text-uppercase text-center font-weight-bold align-middle" style="background-color: #e1e1e1 ;color: black;">Root Cause</td>
                        <td class="text-uppercase text-center font-weight-bold align-middle" style="background-color: #e1e1e1 ;color: black;">Factor of Root Cause</td>
                      </template>
                      <td class="text-uppercase text-center font-weight-bold align-middle" style="background-color: #e1e1e1 ;color: black">Action</td>
                    </tr>
                  </template>
                  <template v-else>
                    <tr>
                      <td rowspan="2" class="text-uppercase text-center font-weight-bold align-middle" style="background-color: #e1e1e1 ;color: black; width: 1em !important;">#</td>
                      <td rowspan="2" class="text-uppercase text-center font-weight-bold align-middle" style="background-color: #e1e1e1 ;color: black">Vessel</td>
                      <td rowspan="2" class="text-uppercase text-center font-weight-bold align-middle" style="background-color: #e1e1e1 ;color: black">Manager</td>
                      <td rowspan="2" class="text-uppercase text-center font-weight-bold align-middle" style="background-color: #e1e1e1 ;color: black">Report Title</td>
                      <td rowspan="2" class="text-uppercase text-center font-weight-bold align-middle" style="background-color: #e1e1e1 ;color: black">Event Date</td>
                      <td rowspan="2" class="text-uppercase text-center font-weight-bold align-middle" style="background-color: #e1e1e1 ;color: black">Event 1</td>
                      <td rowspan="2" class="text-uppercase text-center font-weight-bold align-middle" style="background-color: #e1e1e1 ;color: black">Event 2</td>
                      <td rowspan="2" class="text-uppercase text-center font-weight-bold align-middle" style="background-color: #e1e1e1 ;color: black">Event 3</td>
                      <td rowspan="2" class="text-uppercase text-center font-weight-bold align-middle" style="background-color: #e1e1e1 ;color: black">Event 4</td>
                      <td colspan="4" class="text-uppercase text-center font-weight-bold align-middle" style="background-color: #e1e1e1 ;color: black">Schedule Delay <br>
                        <span style="font-style: italic; color: black">({{ Number(resultEvent.map(item => parseFloat(item.lossTotalDelayedHours)).reduce((acc, curr) => acc + curr, 0)).toFixed(2) }} Hour/s)</span>
                      </td>
                      <td rowspan="2" class="text-uppercase text-center font-weight-bold align-middle" style="background-color: #e1e1e1 ;color: black">Action</td>
                    </tr>
                    <tr>
                      <td class="text-uppercase text-center font-weight-bold align-middle" style="color: black; background-color: #e1e1e1;">Day/s</td>
                      <td class="text-uppercase text-center font-weight-bold align-middle" style="color: black; background-color: #e1e1e1;">Hour/s</td>
                      <td class="text-uppercase text-center font-weight-bold align-middle" style="color: black; background-color: #e1e1e1;">Minute/s</td>
                      <td class="text-uppercase text-center font-weight-bold align-middle" style="color: black; background-color: #e1e1e1;">Total Hour/s</td>
                    </tr>
                  </template>
                  </thead>
                  <tbody>
                  <template v-if="!loading && !resultEvent.length">
                    <tr>
                      <td colspan="100%">
                        <div class="text-center font-weight-bold text-uppercase h5 p-2 mt-2" style="color: black">
                          No Accident / Incidents Found
                        </div>
                      </td>
                    </tr>
                  </template>
                  <template v-else-if="!loading && resultEvent.length">
                    <tr v-for="(data, index) in resultEvent" :key="index">
                      <td class="align-middle text-center p-2">{{pagination?.from + index }}</td>
                      <td class="align-middle text-center p-2">{{data.vessel}}</td>
                      <td class="align-middle text-center p-2">{{data.managementOffice}}</td>
                      <td class="align-middle text-center p-2">{{data.title}}</td>
                      <td class="align-middle text-center p-2">{{data.eventDate}}</td>
                      <td class="align-middle text-center p-2">{{data.eventOne}}</td>
                      <td class="align-middle text-center p-2">{{data.eventTwo}}</td>
                      <td class="align-middle text-center p-2">{{data.eventThree}}</td>
                      <td class="align-middle text-center p-2">{{data.eventFour}}</td>
                      <template v-if="$route.params.chart_module !== 'number_of_report' && $route.params.chart_module !== 'immediate_cause' && $route.params.chart_module !== 'root_cause'">
                        <td class="align-middle text-center p-2">{{data.delaySchedDay}}</td>
                        <td class="align-middle text-center p-2">{{data.delaySchedHours}}</td>
                        <td class="align-middle text-center p-2">{{data.delaySchedMin}}</td>
                        <td class="align-middle text-center p-2">{{data.lossTotalDelayedHours}}</td>
                      </template>
                      <template v-if="$attrs.chart_id === 'ai_imm_cause' && $route.params.chart_module === 'number_of_report'">
                        <td class="align-middle text-center p-2">{{data?.immediateCause}}</td>
                        <td class="align-middle text-center p-2">{{data?.immediateCauseSubCondition}}</td>
                      </template>
                      <template v-if="$attrs.chart_id === 'ai_root_cause' && $route.params.chart_module === 'number_of_report'">
                        <td class="align-middle text-center p-2">{{data?.rootCause}}</td>
                        <td class="align-middle text-center p-2">{{data?.rootCauseFactor}}</td>
                      </template>
                      <template v-if="$route.params.chart_module === 'immediate_cause'">
                        <td class="align-middle text-center p-2">{{data?.immediateCause}}</td>
                        <td class="align-middle text-center p-2">{{data?.immediateCauseSubCondition}}</td>
                      </template>
                      <template v-if="$route.params.chart_module === 'root_cause'">
                        <td class="align-middle text-center p-2">{{data?.rootCause}}</td>
                        <td class="align-middle text-center p-2">{{data?.rootCauseFactor}}</td>
                      </template>
                      <td class="align-middle text-center p-2">
                        <button class="e-btn e-btn-blue e-btn-sm e-text-white my-1" @click="showReport(data.id)">
                          <font-awesome-icon icon="eye"  />
                          View
                        </button>
                      </td>
                    </tr>
                  </template>
                  <template v-else>
                    <tr>
                      <td colspan="100%">
                        <app-loading></app-loading>
                      </td>
                    </tr>
                  </template>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import {mapActions, mapGetters} from "vuex";
import appLoading from "@/components/elements/AppLoading.vue";
import {PaginationMixin} from "@/mixins/PaginationMixin";
import {permissionMixin} from "@/mixins/permissionMixins";
import {ExcelService} from "@/services/ExcelService";

export default {
  name: "InvestigationEventChart",
  mixins:[PaginationMixin, permissionMixin],
  components: {appLoading},
  props: {
    data: {
      type: Array,
      required: true,
    },
    eventsFilter: {
      type: Object,
      default: () => ({}),
    },
    office:{
      type:String|Number,
      default:null,
    },

  },
  data() {
    return {
      selectedEvent: null,
      resultEvent: [],
      loading: false,
      year: null,
      enabledSeriesData: [],
    };
  },
  mounted() {
    const modalId = this.$attrs.chart_id ? this.$attrs.chart_id + '_eventModal' : 'eventModal';
    $("#" + modalId).on('hidden.bs.modal', () => {
      this.resetYear()
    });

    this.updateEnabledSeries()
  },
  computed: {
    ...mapGetters(['pagination','accidentIncidentByEvent']),
    events() {
      return this.data.map((event) => event.event);
    },
    years() {
      return this.data.length ? Object.keys(this.data[0].years) : [];
    },
    series() {
      if (!this.data.length) return [];
      return this.years.map((year) => {
        return {
          name: year,
          data: this.data.map((event) => event.years[year]),
        };
      });
    },
    chartOptions() {
      return {
        chart: {
          type: "bar",
          stacked: false,
          toolbar: {
            show: true,
          },
          events: {
            mounted: () => this.attachLabelClicks(),
            updated: () => this.attachLabelClicks(),
          },
        },
        plotOptions: {
          bar: {
            horizontal: true,
            barHeight: "60%",
          },
        },
        colors: ['#bfbfbf', '#a6a6a6', '#ffd966', '#f7caac', '#f4b083', '#ff0000'],
        xaxis: {
          categories: this.events,
        },
        legend: {
          position: "bottom",
        },
        tooltip: {
          shared: true,
          intersect: false,
        },
        dataLabels: {
          enabled: false,
        },
      };
    },
  },
  methods: {
    ...mapActions(['fetchAccidentIncidentByEvent']),
    async attachLabelClicks() {
      document
        .querySelectorAll(`#${this.$attrs.chart_id} .apexcharts-yaxis-label`)
        .forEach((el, index) => {
          el.style.cursor = "pointer";
          el.onclick = () => {
            this.selectedEvent = this.data[index];
            this.accidentIncidentByEventData(null, null, this.office, this.years);
          };
        });
    },

    async accidentIncidentByEventData(page = null,year=null,office=null, years=[]){
      if (this.isAllowed('menu.reports.accident-incident') === false) {
        return;
      }
      this.loading = true;
      let params = {};
      if(this.$attrs.chart_id === 'ai_imm_cause'){
        params = {
          chartId: this.$attrs.chart_id,
          eventSelected: this.selectedEvent?.eventId,
          eventOneId: this.eventsFilter.event_one_id,
          eventTwoId: this.eventsFilter.event_two_id,
          eventThreeId: this.eventsFilter.event_three_id,
          eventFourId: this.eventsFilter.event_four_id,
          eventFiveId: this.eventsFilter.event_five_id,
          page:page ?? 1,
          year:year ?? null,
          years:years ?? [],
          office: office ?? null,
        }
      } else if(this.$attrs.chart_id === 'ai_root_cause'){
        params = {
          chartId: this.$attrs.chart_id,
          eventSelected: this.selectedEvent?.eventId,
          eventOneId: this.eventsFilter.event_one_id,
          eventTwoId: this.eventsFilter.event_two_id,
          eventThreeId: this.eventsFilter.event_three_id,
          eventFourId: this.eventsFilter.event_four_id,
          eventFiveId: this.eventsFilter.event_five_id,
          page:page ?? 1,
          year:year ?? null,
          years:years ?? [],
          office: office ?? null,
        }
      } else{
        params = {
          eventSelected:this.selectedEvent?.eventId,
          eventOneId: this.eventsFilter.event_one_id,
          eventTwoId: this.eventsFilter.event_two_id,
          eventThreeId: this.eventsFilter.event_three_id,
          eventFourId: this.eventsFilter.event_four_id,
          eventFiveId: this.eventsFilter.event_five_id,
          page:page ?? 1,
          year:year ?? null,
          years:years ?? [],
          office: office ?? null,
        }
      }

      if (this.$route?.params?.chart_module === 'immediate_cause') {
        params.sub_act_id = this.eventsFilter.sub_act_id ?? null;
        params.sub_con_id = this.eventsFilter.sub_con_id ?? null;
      }
      if (this.$route?.params?.chart_module === 'root_cause') {
        params.rc_cause_id = this.eventsFilter.rc_cause_id ?? null;
        params.rc_factor_id = this.eventsFilter.rc_factor_id ?? null;
      }
      if (this.$route?.params?.chart_module === 'number_of_delay') {
        params.delay_module = this.$route.params.chart_module;
      }

      if (this.$route?.params?.chart_module === 'delay_hours') {
        params.delay_module = this.$route.params.chart_module;
      }
      await this.fetchAccidentIncidentByEvent(params)
      this.resultEvent = this.accidentIncidentByEvent;
      const modalId = this.$attrs.chart_id ? this.$attrs.chart_id + '_eventModal' : 'eventModal';
      $("#" + modalId).modal("show");
      this.loading = false;
    },
    resetYear(){
      this.year = null
    },
    accidentIncidentsByEventAndYear(){
      this.accidentIncidentByEventData(null,this.year,this.office, this.years)
    },
    updateEnabledSeries() {
      this.$nextTick(() => {
        const chart = this.$refs.chart;
        if (!chart || !chart.chart) return;

        this.enabledSeriesData = chart.chart.w.globals.seriesNames.filter(
          (_, i) => !chart.chart.w.globals.collapsedSeriesIndices.includes(i)
        );

        this.$emit('series-updated', this.enabledSeriesData?.length < 1);
      });
    },
    async generateCsv(){
      swal.fire({
        'title': 'GENERATING CSV FILE',
        allowEscapeKey:false,
        allowEnterKey:false,
        allowOutsideClick:false,
      })
      swal.showLoading()

      let params = {};
      if(this.$attrs.chart_id === 'ai_imm_cause'){
        params = {
          chartId: this.$attrs.chart_id,
          eventSelected: this.selectedEvent?.eventId,
          eventOneId: this.eventsFilter.event_one_id,
          eventTwoId: this.eventsFilter.event_two_id,
          eventThreeId: this.eventsFilter.event_three_id,
          eventFourId: this.eventsFilter.event_four_id,
          eventFiveId: this.eventsFilter.event_five_id,
          year: this.year ?? null,
          years: this.years ?? [],
          office: this.office ?? null,
        }
      } else if(this.$attrs.chart_id === 'ai_root_cause'){
        params = {
          chartId: this.$attrs.chart_id,
          eventSelected: this.selectedEvent?.eventId,
          eventOneId: this.eventsFilter.event_one_id,
          eventTwoId: this.eventsFilter.event_two_id,
          eventThreeId: this.eventsFilter.event_three_id,
          eventFourId: this.eventsFilter.event_four_id,
          eventFiveId: this.eventsFilter.event_five_id,
          year: this.year ?? null,
          years: this.years ?? [],
          office: this.office ?? null,
        }
      } else{
        params = {
          eventSelected:this.selectedEvent?.eventId,
          eventOneId: this.eventsFilter.event_one_id,
          eventTwoId: this.eventsFilter.event_two_id,
          eventThreeId: this.eventsFilter.event_three_id,
          eventFourId: this.eventsFilter.event_four_id,
          eventFiveId: this.eventsFilter.event_five_id,
          year: this.year ?? null,
          years: this.years ?? [],
          office: this.office ?? null,
        }
      }

      if (this.$route.params.chart_module === 'immediate_cause') {
        params.sub_act_id = this.eventsFilter?.sub_act_id ?? null;
        params.sub_con_id = this.eventsFilter?.sub_con_id ?? null;
      }

      if (this.$route.params.chart_module === 'root_cause') {
        params.rc_cause_id = this.eventsFilter?.rc_cause_id ?? null;
        params.rc_factor_id = this.eventsFilter?.rc_factor_id ?? null;
      }

      if (this.$route?.params?.chart_module === 'number_of_delay') {
        params.delay_module = this.$route.params.chart_module;
      }

      if (this.$route?.params?.chart_module === 'delay_hours') {
        params.delay_module = this.$route.params.chart_module;
      }

      await ExcelService.csv('ACCIDENT_INCIDENT_BY_EVENT', params);

      swal.close();
    },
    async showReport (reportId) {
      var routelink = null;

      if(this.$route.params.chart_module === 'number_of_report'){
        routelink = 'General';
      }
      else if(this.$route.params.chart_module === 'immediate_cause' || this.$route.params.chart_module === 'root_cause'){
        routelink = 'Cause';
      }
      else{
        routelink = 'Loss';
      }
      const routeName = routelink
      const route= this.$router.resolve(
        {
          name: routeName,
          params: {
            id: reportId,
          },
        },
      )
      window.open(route.href,'_blank')
    },
  },
  watch:{
    // 'year'(val){
    //   this.accidentIncidentByEventData(null,val,this.office)
    // }
  }
};
</script>
